import axios from 'axios';
import _ from 'lodash';
import config from '../utils/config';

const getInvoicesApi = async (invoiceId, status, startDate, endDate) => {
  let url = `${config.serverBasePath}/api/v2/invoices`;
  let query = [];
  if (!_.isEmpty(invoiceId) || !_.isEmpty(status) || !_.isEmpty(startDate) || !_.isEmpty(endDate)) {
    query.push(!_.isEmpty(invoiceId) ? `invoice_id=${invoiceId}` : '');
    query.push(!_.isEmpty(status) ? `status=${status}` : '');
    query.push(!_.isEmpty(startDate) ? `start_date=${startDate}` : '');
    query.push(!_.isEmpty(endDate) ? `end_date=${endDate}` : '');
    query = _.join(_.filter(query, (q) => q !== ''), '&');
    url += `?${query}`;
  }

  const accessToken = await window.localStorage.getItem('access_token');
  const response = await axios.request({
    url,
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      withCredentials: true,
      Authorization: `Bearer ${accessToken}`,
      'Access-Control-Allow-Origin': '*'
    },
  });
  return response.data;
};

export default getInvoicesApi;
